import {
  GqlModel,
  GqlModelOperator,
  GqlMutationModel,
} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonProperty} from "../json.model";

export class UpdateContractAccountInputResponseGqlModel extends GqlModel {
  @jsonProperty("string") id: string;
  @jsonProperty("boolean") updated: boolean;
}

export class UpdateContractAccountGqlModel extends GqlMutationModel {
  static mapper: GqlModelOperator<UpdateContractAccountInputResponseGqlModel> =
    GqlModel.buildMapper(UpdateContractAccountInputResponseGqlModel, "updateContractAccount");

  static query = gql`
    mutation updateContractAccount($caName: String!, $pendingCaName: String, $projectId: String, $status: Int) {
       updateContractAccount( caName: $caName, pendingCaName:$pendingCaName, projectId: $projectId, status:$status) {
        id
        updated
      }
    }
  `;

  @jsonProperty("string") projectId: string;
  @jsonProperty("string") caName: string;
  @jsonProperty("string") pendingCaName: string;
  @jsonProperty("number") status: number;
}
